export default "__VITE_ASSET__BAQkv7W4__"